import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import './style.css';
import { onClickNotif } from 'actions/notifications';

class NotificationBar extends React.Component {
  render() {
    const {
      sidebarNotification,
      onCloseButtonClick,
      notification,
      location,
    } = this.props;
    const { bars, notificationClicked } = notification;
    const { pathname } = location;

    const doms = bars.map(function(bar, index) {
      const notificationCursor = bar.targetLocation ? 'pointer-cursor' : '';
      if (sidebarNotification) {
        return (
          !notificationClicked && (
            <div
              key={index}
              className={
                pathname === '/reports/invoices' ||
                pathname === '/reports/transactions'
                  ? `mk-alert-box-trx-inv trans-1 ${bar.level} sidebar-notification ${notificationCursor}`
                  : `mk-alert-box trans-1 ${bar.level} sidebar-notification ${notificationCursor}`
              }
              onClick={() => this._onNotificationClicked(bar.targetLocation)}
            >
              <div className="container">
                <div
                  className={
                    bar.message && bar.message.length > 37
                      ? `mk-alert pad2 closeable-${bar.closeable}`
                      : `mk-alert pad11 closeable-${bar.closeable}`
                  }
                >
                  <div>
                    {bar.closeable && (
                      <a
                        onClick={onCloseButtonClick}
                        href="#"
                        className="close"
                        data-dismiss="alert"
                        aria-label="close"
                      >
                        &times;
                      </a>
                    )}
                    {bar.message}
                  </div>
                </div>
              </div>
            </div>
          )
        );
      }
      return (
        !notificationClicked && (
          <div
            key={index}
            className={
              pathname === '/reports/invoices' ||
              pathname === '/reports/transactions'
                ? `mk-alert-box-trx-inv trans-1 ${bar.level}`
                : `mk-alert-box trans-1 ${bar.level}`
            }
          >
            <div className="container">
              <div
                className={
                  bar.message.length > 37 ? 'mk-alert pad2' : 'mk-alert pad11'
                }
              >
                <div>{bar.message}</div>
              </div>
            </div>
          </div>
        )
      );
    }, this);

    return <div>{doms}</div>;
  }

  _onNotificationClicked = targetLocation => {
    if (targetLocation) window.location = targetLocation;
  };
}

NotificationBar.defaultProps = {
  onCloseButtonClick: () => {},
};

NotificationBar.propTypes = {
  notification: PropTypes.object,
  onCloseButtonClick: PropTypes.func,
  location: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
  return {
    onCloseButtonClick: () => {
      dispatch(onClickNotif(true));
    },
  };
}

export default connect(
  null,
  mapDispatchToProps
)(NotificationBar);
